export class GpsCoordinates {
    latitude?:  number;
    longitude?: number;

	constructor() {
		this.latitude = 0;
		this.longitude = 0;
	}
}
